import thunk from 'redux-thunk'
import { applyMiddleware, compose } from 'redux'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

let ex = applyMiddleware(thunk)
if (process.env.NODE_ENV !== 'production') ex = composeEnhancers(applyMiddleware(thunk))

export default ex